module.exports = __webpack_public_path__ + "static/img/menu-xs-light.7c729bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/menu-xs-light.png
// module id = e+aC
// module chunks = 2